let info = {
  name: "Julio Notodiprodyo",
  logo_name: "JN",
  flat_picture: require("./src/assets/me.jpeg"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false
    },
    music: {
      src: "/audio/boompa.mp3",
      volume: 0.5,
      autoplay: true,
      attribution: "boompa"
    }
  },
  description:
    "Hi! I'm Julio Notodiprodyo 👋<br> I've been programming every day for the past 10 years. On the days that I'm not able to directly write code, I read books and watch courses.<br> <br> I consider myself a shameless cloner - I try to learn from everyone. I write down everything that makes sense to me and could potentially benefit me and increase my productivity.<br><br> My view has been - I don't have enough time to figure out a lot of these things on my own, so I've decided to abandon my ego and try to learn as much from others as possible.<br><br> I like finding new ways to save myself time - automating things, solving problems, writing clean code.",
  links: {
    linkedin: "https://www.linkedin.com/in/julio-notodiprodyo-b6154010a/",
    github: "https://github.com/njulioiyoo",
    resume: "https://drive.google.com/file/d/1V05NPReu6-5TjwtK5A5mHuaqe9qDl04e/view?usp=sharing",
  },
  education: [
    {
      "name": "Bina Sarana Informatika",
      "place": "Bekasi City",
      "date": "2014 - 2017",
      "degree": "Informatics Management",
      "gpa": "3.19",
      "description": "",
      "skills": [
        "PostgreSQL",
        "MariaDB",
        "MySQL",
        "SQL Server",
        "ElasticSearch",
        "Redis",
        "AWS",
        "GCP",
        "Docker",
        "Kong Gateway",
        "Laravel",
        "CodeIgniter",
        "Symfony",
        "CakePHP",
        "Vue.js",
        "Node.js",
        "Nuxt.js",
        "RAG",
        "OpenAI"
      ]
    }
  ],
  experience: [
    {
      "name": "Curv Creative",
      "place": "Jakarta · Remote",
      "date": "Jan 2026 - Present · 2 mos",
      "position": "Freelance Software Engineer · Contract",
      "description": "• Worked as a Freelance Software Engineer supporting client projects through a consulting company.\n• Developed and maintained web applications based on project requirements.\n• Collaborated with project managers and other engineers to deliver solutions on time.\n• Performed debugging, optimization, and feature enhancements.\n• Ensured code quality and followed best practices in software development.",
      "skills": [
        "Vue.js",
        "Rest API",
        "Node.js",
        "Laravel"
      ]
    },
    {
      "name": "DBC Group",
      "place": "Cibitung, West Java",
      "date": "May 2025 - Present",
      "position": "Software Engineer",
      "description": "• Developed various applications based on user requirements and built AI solutions using RAG (Retrieval-Augmented Generation).\n• Delivered and maintained internal business applications spanning maintenance scheduling, procurement, quality management, legal, and system migrations.\n• Built Timebase, E-Contract, BASO (EBA), HDS, QIS, DIAS, RAG AI Chatbot, and Qmatrix.\n• Migrated Marketing System database from MySQL to SQL Server.\n• Modernized Budget System and KWH Meter DTU from PHP to JavaScript, including database migration.\n• Led internal sharing sessions on AWS, RAG, SonarQube, and cookie-based storage.",
      "skills": [
        "Vue.js",
        "Node.js",
        "RAG",
        "OpenAI",
        "pgVector",
        "Laravel",
        "Rest API",
        "PostgreSQL",
        "Redis",
        "AWS",
        "Docker",
        "SQL Server"
      ]
    },
    {
      "name": "PT Koltiva AG",
      "place": "Mampang Prapatan, South Jakarta",
      "date": "June 2021 - May 2025",
      "position": "Software Engineer",
      "description": "• Responsible for full-stack development, building robust REST APIs, Swagger documentation, and GIS-integrated applications.\n• Developed REST APIs with Swagger documentation and implemented GIS on QR with Tips Donation feature.\n• Built Academic Information System, Letter Disposition Application, and web-based GIS with regional monitoring and search functionalities.",
      "skills": [
        "Vue.js",
        "ElasticSearch",
        "Rest API",
        "GIS",
        "AWS",
        "Google Maps API",
        "Swagger API",
        "CodeIgniter",
        "Laravel"
      ]
    },
    {
      "name": "PT MNC Investama",
      "place": "Kebon Sirih, Central Jakarta",
      "date": "December 2017 - June 2021",
      "position": "Software Engineer",
      "description": "• Responsible for full-stack development across streaming, artist management, and payment integration.\n• Built and maintained iGetSpot, StarHits, Vision+ streaming, and MNC Peduli charity platform.\n• Integrated NicePay Payment Gateway, developed MNC Group portals, MDM, Lumen APIs, and Elasticsearch.",
      "skills": [
        "Vue.js",
        "ElasticSearch",
        "Rest API",
        "CodeIgniter",
        "Laravel",
        "Quasar Framework",
        "CakePHP",
        "NicePay"
      ]
    },
    {
      "name": "PT Elnet Media Karya",
      "place": "Kebon Jeruk, West Jakarta",
      "date": "June 2016 - December 2017",
      "position": "Software Engineer",
      "description": "• Developed ERP software solutions to enhance customer service operations and improve operational efficiency.\n• Successfully integrated PABX systems, enabling seamless communication infrastructure across the organization.",
      "skills": [
        "ERP",
        "PABX Systems",
        "CodeIgniter"
      ]
    },
    {
      "name": "PT Chandra Nugerah Cemerlang (CNC Group)",
      "place": "Cikarang Selatan, West Java",
      "date": "May 2012 - June 2015",
      "position": "Quality Assurance",
      "description": "• Drafted QA policies and procedures, evaluated QA standards, and reviewed the implementation of quality systems.\n• Planned, conducted, and monitored testing while analyzing quality data to drive continuous improvement.\n• Developed comprehensive QA policies aligned with industry standards and fostered cross-departmental collaboration.",
      "skills": [
        "Understanding of Manufacturing Processes",
        "Analytical Skills",
        "Understanding of Quality Standards",
        "Communication Skills",
        "Problem-Solving",
        "Use of QC Tools and Methods",
        "Team Management Skills",
        "Attention to Detail"
      ]
    }
  ],
  skills: [
    {
      title: "Databases & Storage",
      info: [
        "PostgreSQL", "MariaDB", "MySQL", "SQL Server", "ElasticSearch", "Redis"],
      icon: "fas fa-database"
    },
    {
      title: "Cloud & Infrastructure",
      info: [
        "AWS (Lambda, SNS, SQS, S3)", "GCP", "Docker", "Kong Gateway"],
      icon: "fas fa-cloud"
    },
    {
      title: "PHP Ecosystem",
      info: [
        "Laravel", "CodeIgniter", "Symfony", "CakePHP"],
      icon: "fa fa-code"
    },
    {
      title: "JavaScript Ecosystem",
      info: [
        "Vue.js", "Node.js", "Nuxt.js", "Express.js", "React.js"],
      icon: "fas fa-laptop-code"
    },
    {
      title: "AI / ML",
      info: [
        "RAG (pgVector)", "OpenAI"],
      icon: "fas fa-robot"
    },
  ],
  portfolio: [
    {
      name: "Tez Capital Finance",
      pictures: [
        {
          img: require("./src/assets/portfolio/tezcapitalfinance/1.png")
        },
        {
          img: require("./src/assets/portfolio/tezcapitalfinance/2.png")
        },
      ],
      technologies: ["Laravel", "Vue Framework", "pgSQL"],
      category: "Web App",
      date: "Juni, 2025 - 1 days",
      github:
        "#",
      visit: "https://tezcapitalfinance.co.id",
      description:
        " Fast, Flexible, Reliable Financing Solutions. "
    },
    {
      name: "QR Code",
      pictures: [
        {
          img: require("./src/assets/portfolio/qrcode/1.png")
        },
        {
          img: require("./src/assets/portfolio/qrcode/2.png")
        },
        {
          img: require("./src/assets/portfolio/qrcode/3.png")
        },
        {
          img: require("./src/assets/portfolio/qrcode/4.png")
        },
      ],
      technologies: ["Laravel", "Vue Framework", "AWS", "Redis"],
      category: "Web App",
      date: "April, 2024 - 1 days",
      github:
        "#",
      visit: "https://qr.koltitrace.com/YXBwLTE5NjU0LWJhdGNoLWtvbHRpdHJhY2U",
      description:
        " This platform digitally documents every stage of the production process, from sourcing raw materials to the final steps of packaging and distribution.. "
    },
    {
      name: "Alfurqon Mosque",
      pictures: [
        {
          img: require("./src/assets/portfolio/alfurqon/1.png")
        },
      ],
      technologies: ["Laravel"],
      category: "Web App",
      date: "April, 2024 - 3 days",
      github:
        "https://github.com/njulioiyoo/backend-alfurqon",
      visit: "#",
      description:
        " Masjid Alfurqon provides information regarding lecture schedules, mosque expenses, and other matters. "
    },
    {
      name: "LegaTV",
      pictures: [
        {
          img: require("./src/assets/portfolio/legatv/1.png")
        },
      ],
      technologies: ["Laravel"],
      category: "Web App",
      date: "April, 2024 - 4 days",
      github:
        "https://github.com/njulioiyoo/LegaTV",
      visit: "#",
      description:
        " Lega TV is a portal for local news and television broadcasts. "
    },
    {
      name: "MNC Animation",
      pictures: [
        {
          img: require("./src/assets/portfolio/mncanimation/1.png")
        },
        {
          img: require("./src/assets/portfolio/mncanimation/2.png")
        },
        {
          img: require("./src/assets/portfolio/mncanimation/3.png")
        },
      ],
      technologies: ["Laravel"],
      category: "Web App",
      date: "April, 2024 - 5 days",
      github:
        "#",
      visit: "https://mncanimation.com",
      description:
        " MNC Animation (“MNCA” or “The Company”) was established in Jakarta on May 22, 2011, as part of PT MNC Studios International Tbk (“MSIN”), the content production unit of MNC Group, the largest and most integrated media company in South East Asia. MNC Animation is where creative inspiration meets technological innovation, as the company aspires to continue producing content that informs, entertains and captivates its audience. The company focuses on creating and producing original works and developing Intellectual Properties (IPs) into state-of-the-art animation productions and other related IP businesses that emphasizes on high-quality distributed through a variety of media platforms. "
    },
    {
      name: "MNC Peduli",
      pictures: [
        {
          img: require("./src/assets/portfolio/mncpeduli/1.png")
        },
        {
          img: require("./src/assets/portfolio/mncpeduli/2.png")
        },
        {
          img: require("./src/assets/portfolio/mncpeduli/3.png")
        },
      ],
      technologies: ["Laravel", "Rest API", "CakePHP"],
      category: "Web App",
      date: "April, 2024 - 7 days",
      github: "#",
      visit: "https://mncpeduli.org",
      description:
        " MNC Peduli's other activities that are felt by the wider community, especially the disadvantaged people who need assistance, are also carried out by MNC Peduli through the Yayasan Brainan Kasih (based on the founding deed number: 99/2013 and licensing at the Ministry of Social Affairs of the Republic of Indonesia). "
    },
    {
      name: "MNC Group",
      pictures: [
        {
          img: require("./src/assets/portfolio/mncgroup/1.png")
        },
        {
          img: require("./src/assets/portfolio/mncgroup/2.png")
        },
        {
          img: require("./src/assets/portfolio/mncgroup/mobile.gif")
        },
      ],
      technologies: ["Laravel", "Rest API", "CakePHP"],
      category: "Web App",
      date: "April, 2024 - 8 days",
      github:
        "#",
      visit: "https://mncgroup.com",
      description:
        " Founded in 1989, MNC Group focuses on 4 strategic businesses: Media & Entertainment, Financial Services, Entertainment Hospitality, and Energy. "
    },
    {
      name: "VisionPlus",
      pictures: [
        {
          img: require("./src/assets/portfolio/visionplus/1.jpeg")
        },
      ],
      technologies: ["Quasar Framework"],
      category: "Web App",
      date: "April, 2024 - 11 days",
      github:
        "#",
      visit: "https://visionplus.id",
      description:
        " Enjoy VISION+, movies and streaming series on your PC, Mac, mobile, tablet and more devices. "
    },
    {
      name: "RCTIAds",
      pictures: [
        {
          img: require("./src/assets/portfolio/rctiads/1.jpeg")
        },
      ],
      technologies: ["Laravel"],
      category: "Web App",
      date: "April, 2024 - 13 days",
      github:
        "#",
      visit: "https://rctiads.com",
      description:
        " RCTI Ads is a self-service advertising solution across various MNC Media platforms, including TV and Digital Media. "
    },
    {
      name: "Starhits",
      pictures: [
        {
          img: require("./src/assets/portfolio/starhits/1.png")
        },
      ],
      technologies: ["Laravel"],
      category: "Web App",
      date: "April, 2024 - 14 days",
      github:
        "#",
      visit: "https://starhits.id",
      description:
        " StarHits (Suara Mas Abadi) is Digital media company that provides services, in terms of creating, distributing, managing, monetization of content. "
    },
  ],
};

export default info;
